import { Bank, CaretLeft, Check, CreditCard } from "@phosphor-icons/react";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const fundingMethods = [
  {
    id: "card",
    name: "Fund with Card",
    description: "Add funds to your wallet through your linked card",
    icon: CreditCard,
    navigateTo: "fund-with-card",
  },
  {
    id: "account",
    name: "Bank Transfer",
    description: "Add funds to your wallet through your virtual bank account",
    icon: Bank,
    navigateTo: "virtual-account-details",
  },
];

const SelectFundMethod = () => {
  const navigate = useNavigate();
  // Carries a checkout `returnTo` through to the chosen funding screen.
  const location = useLocation();
  const [selectedMethod, setSelectedMethod] = useState<string | null>(null);
  return (
    <div>
      <div className="flex items-center justify-center gap-10 px-5 py-20 text-center flex-col">
        <div className="flex flex-col gap-2">
          <div className="font-semibold text-3xl">
            How would you like to fund your account?
          </div>
          <div className="text-gray-500">
            Choose a funding method to add money to your wallet
          </div>
        </div>
        <div className="c-groupedSelect c-groupedSelect--vertical">
          {fundingMethods.map((type, key) => {
            return (
              <button
                key={key}
                onClick={() => {
                  setSelectedMethod(type.navigateTo);
                }}
                className={`c-groupedSelect__option ${
                  selectedMethod === type.navigateTo && "active"
                }`}
              >
                <div className="text-visaro-orange rounded-full p-3 bg-visaro-orange/10">
                  <type.icon weight="bold" size={24} />
                </div>
                <div className="flex-1 flex-col text-left">
                  <div className="text-lg font-medium">{type.name}</div>
                  <div className="text-sm text-gray-700">
                    {type.description}
                  </div>
                </div>
                {selectedMethod === type.navigateTo ? (
                  <div className="bg-visaro-orange p-2 rounded-full">
                    <Check className="text-white" weight="bold" size={16} />
                  </div>
                ) : (
                  <div className=" p-2 rounded-full">
                    <Check
                      className="text-white invisible"
                      weight="bold"
                      size={16}
                    />
                  </div>
                )}
              </button>
            );
          })}
          <br />
          <div className="flex justify-between gap-2">
            <button
              type="button"
              onClick={() => navigate(-1)}
              className="p-2 py-3 text-center text-deepBlue border px-6 rounded-xl font-medium flex gap-2 items-center border-gray-300"
            >
              <CaretLeft weight="bold" size={20} />
              <span>Back</span>
            </button>
            <button
              onClick={() =>
                navigate(selectedMethod || "", { state: location.state })
              }
              disabled={!selectedMethod}
              className="p-2 py-3 text-center bg-deepBlue text-white px-10 border-2 rounded-xl font-medium"
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectFundMethod;
